 
import { useState, useEffect, useRef } from "react";
import MKTypography from "components/MKTypography"; 
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from "@mui/material/InputAdornment"; 
import SearchIcon from "@mui/icons-material/Search";
import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card"; 

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import Divider from "@mui/material/Divider";
import MKBadge from "components/MKBadge";

import Pagination from '@mui/material/Pagination';
import { startAuthentication} from '@simplewebauthn/browser';
import AppSignup from "components/AppKey/AppSignup";
import AppLogin from "components/AppKey/AppLogin";

 
import Dropdowns from "components/AppKey/Dropdowns";
import { appAuth } from "../../contexts/AppContext"
import { useAuth } from "../../contexts/AuthContext"
import AppGroup from "./AppGroup";
import AddUserGroup from "./AddUserGroup";
 

export default function AppUser({app}) { 

    const {verify, verifyComplete} = useAuth()
    const {currentApp, deleteAppSignup, deleteAppUser, updateAppUserStatus, createAppInvite, resetAppUserPasskey, verifyUserComplete, verifyUser, setRequestError, setRequestSuccess, 
        deleteAppGroup, getAppSignup, getAppUser, getAppGroup, updateAppGroup, updateAppUserGroup, exportAppUser} = appAuth()
    const [filter, setFilter] = useState({appId:app.appId, type:"all", groupId:null, limit:25, offset: 0})
    const [search, setSearch] = useState("")
    const [signupData, setSignupData] = useState([]);
    const [signupDataRender, setSignupDataRender] = useState([]);
    const [userData, setUserData] = useState([]);
    const [userDataRender, setUserDataRender] = useState([]);
    const [showAnonymous, setShowAnonymous] = useState(true);
  
    const [groupData, setGroupData] = useState([]);
    const [groupDataRender, setGroupDataRender] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState("None");

    const [inputData, setInputData] = useState({})
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [total, setTotal] = useState();

    const [modalState, setModalState] = useState({
        activeTabUser:1,
        showSignup:false,
        showLogin:false,
        showAnonymousLogin:false,
        showCreateSignup:false,
        showCreateInvite:false,
        showCreateGroup: false,
        showVerify:false,
        showDeleteAppUser:false,
        showDeleteSignup:false,
        showEditAppUser:false,
        showAddUserGroup:false,
        showEditAppGroup:false,
        showDeleteAppGroup:false,
        user:{},
        group:{}

    });

    
    const groupTableHeader = [
        { id: "groupId", name: "groupId", align: "center" }, 
        { id: "name",  name: "name", align: "center" },  
        { id: "desc",  name: "description", align: "center" },  
        { id: "totalUser", name: "users", align: "center" }, 
        { id: "status", name: "status", align: "center" }, 
        { id: "created", name: "created", align: "center" }, 
        { id: "control", name: "control", align: "center" },
    ]

    const signUpTableHeader = [
        
        { id: "handle",  name: "handle", align: "center" }, 
        { id: "displayName",  name: "Name", align: "center" }, 
        { id: "status", name: "status", align: "center" }, 
        { id: "created", name: "created", align: "center" }, 
        { id: "control", name: "control", align: "center" },
    ]

    let userTableHeader = [
        { id:"number", name: "no", align: "left", maxWidth:100 },
        { id: "handle",  name: "handle", align: "center" },
        { id: "displayName",  name: "Name", align: "center" }, 
        { id: "loginProvider",  name: "login Provider", align: "center" }, 
        { id: "status", name: "status", align: "center" },
        { id: "lastLogin", name: "lastLogin", align: "center" },
        { id: "created", name: "created", align: "center" }, 
        { id: "control", name: "control", align: "center" },
    ]

    if(app.userNamesEnabled) {
        userTableHeader = [

            { id:"number", name: "no", align: "left", maxWidth:100  },
            { id: "handle",  name: "handle", align: "center" },
            { id: "displayName",  name: "Name", align: "center" }, 
            { id: "userName",  name: "userName", align: "center" }, 
            { id: "loginProvider",  name: "login Provider", align: "center" }, 
            { id: "status", name: "status", align: "center" },
            { id: "lastLogin", name: "lastLogin", align: "center" },
            { id: "created", name: "created", align: "center" }, 
            { id: "control", name: "control", align: "center" },

            
        ]
    }


    const renderRef = useRef(false)

 
    useEffect(() => {
        
        

        if (renderRef.current === false){
            setModalState({ ...modalState, ["activeTabUser"]:1 }); 
            return () => {
                renderRef.current = true
                console.log("render clean up. ")
            }
        }

    }, [])



    useEffect(() => {

        if (!currentApp) {
            return
        } 
        console.log("activeTabUser modalState.activeTabUser  ", modalState.activeTabUser )

        if(modalState.activeTabUser === 1){
            getAppUserData()
            getAppGroupData(true)
        } 
        else if(modalState.activeTabUser === 2) getAppSignupData()
        else if(modalState.activeTabUser === 3) getAppGroupData()

    }, [modalState.activeTabUser])



    useEffect(() => {
        applyFilter()
        console.log("useEffect selectedGroup ", selectedGroup )

    }, [page, rowsPerPage, selectedGroup])


    const applyFilter = async () => {  
        console.log("applyFilter modalState.activeTabUser  ", modalState.activeTabUser )
        if (modalState.activeTabUser === 1) getAppUserData()
        else if (modalState.activeTabUser === 2) getAppSignupData()
        else if(modalState.activeTabUser === 3) getAppGroupData()

    }
 

    const getAppSignupData = async() => {
       
        setFilter({
            ...filter,
            ["search"]: search
        });

        let result = await getAppSignup(filter)

        setSignupData(prevItems => { 
            return [];
        }); 

        setSignupDataRender(prevItems => { 
            return [];
        }); 

        setTotal(result && result.total ? result.total : 0)


        if (!result || !result.data) return

       

        for (let index = 0; index < result.data.length; index++) {

            
            let element = makeSignupRecord(result.data[index], index); 
            //element.number = index + 1

        
            setSignupData(prevItems => { 
                return [...prevItems, element];
            });  

            setSignupDataRender(prevItems => { 
                return [...prevItems, element];
            });  
                
             
        } 
    }

    
    const getAppGroupData = async(forApp = false) => {
     

        setFilter({
            ...filter,
            ["search"]: search
        });

        let result = await getAppGroup(filter)

        setGroupData(prevItems => { 
            return [];
        }); 

        setGroupDataRender(prevItems => { 
            return [];
        });  

        if(!forApp) setTotal(result && result.total ? result.total : 0)


        if (!result || !result.data) return 

        for (let index = 0; index < result.data.length; index++) {
            
            let element = makeGroupRecord(result.data[index]); 
            element.number = index + 1 
          
            setGroupData(prevItems => { 
                return [...prevItems, element];
            });  

            setGroupDataRender(prevItems => { 
                return [...prevItems, element];
            });  
            
           
        } 
    }



    const getAppUserData = async() => { 
       

        setFilter({
            ...filter, 
            ["search"]: search
        });
       
        console.log("getAppUserData filter ", filter)

        let result = await getAppUser(filter)

        setUserData(prevItems => { 
            return [];
        }); 

        setUserDataRender(prevItems => { 
            return [];
        });  

        setTotal(result && result.total ? result.total : 0) 
        
        if (!result || !result.data) return 

        console.log("getAppUserData result.total ", result.total)

        for (let index = 0; index < result.data.length; index++) {
            
            let element = makeUserRecord(result.data[index]); 
            element.number = index + 1 

            setUserData(prevItems => { 
                return [...prevItems, element];
            });  

            setUserDataRender(prevItems => { 
                return [...prevItems, element];
            });  
            
           
        } 
    }



    const handleTabUserType = (event, newValue) => {

        console.log("handleTabUserType newValue = ", newValue)
        setModalState({ ...modalState, ["activeTabUser"]:newValue }); 
    }

    function onKeyEnterSearch(event){
        if(event.keyCode == 13) applyFilter()
    }
 
    function onSearchUserSignup (evt)  { 
        let value = evt.target.value
        setSearch(value)
      
        if(modalState.activeTabUser === 1){ 
            setUserDataRender(
                userData.filter(data =>
                    data.handle.indexOf(value) >= 0
            )); 

        } 
        else if(modalState.activeTabUser === 2){ 
            setSignupDataRender(
                signupData.filter(data =>
                data.handle.indexOf(value) >= 0
            )); 

        }
        else if(modalState.activeTabUser === 3){ 
            setGroupDataRender(
                groupData.filter(data =>
                    data.name.indexOf(value) >= 0 || data.displayName.indexOf(value) >= 0
            )); 

        }

        if(search === "") applyFilter()

    }

    const setMessage = (message, type = "success") => {
        if(type === "error") setRequestError({message})
        else setRequestSuccess({message})
    }

    const toggleCreateSignupModal = () => { 
        
        if (app.signup == "open")  setModalState({ ...modalState, ["showSignup"]:!modalState.showSignup })  
        else  setModalState({ ...modalState, ["showCreateInvite"]:!modalState.showCreateInvite })   
    }


    const toggleVerifyModal = () => { 
       
        setModalState({ ...modalState, ["showVerify"]:!modalState.showVerify })   
        
    }

    
    const toggleCreateGroupModal = () => { 
        setModalState({ ...modalState, ["showCreateGroup"]:!modalState.showCreateGroup })   
    }

    

    const toggleTestUserModal = (type) => {   
        setModalState({ ...modalState, [type]:!modalState[type] })   
    }

    const toggleDeleteSignupModal = (item) => {
        setModalState({ ...modalState, ["showDeleteSignup"]:!modalState.showDeleteSignup, signUpToDelete:item })   

    }

    const toggleDeleteAppUserModal = (item) => {
        setModalState({ ...modalState, ["showDeleteAppUser"]:!modalState.showDeleteAppUser, user:item })   
    }


    const toggleEditAppUserModal = (item) => {
        setModalState({ ...modalState, ["showEditAppUser"]:!modalState.showEditAppUser, user:item })   
    }

    
    const toggleAddUserGroupModal = () => {
        setModalState({ ...modalState, ["showAddUserGroup"]:!modalState.showAddUserGroup })   
    }

    
    const toggleEditAppGroupModal = (item) => {
        setModalState({ ...modalState, ["showEditAppGroup"]:!modalState.showEditAppGroup, group:item })   
    }

    
    const toggleDeleteAppGroupModal = (item) => {
        setModalState({ ...modalState, ["showDeleteAppGroup"]:!modalState.showDeleteAppGroup, group:item })   
    }


    
    const submitUpdateUserGroup = async (selectedData) => {

        if(selectedData.toAddUser.length === 0 && selectedData.toRemoveUser.length === 0){
            toggleAddUserGroupModal()
            return
        } 

        selectedData.appId = app.appId
        selectedData.groupId = selectedGroup.split(" - ")[0]; 

        let result = await updateAppUserGroup(selectedData);

        if(result) {
            toggleAddUserGroupModal()
          
            setFilter({
                ...filter,
                ["groupId"]:  selectedData.groupId 
            });
            getAppUserData()
        } 
        
    }


    const loginAnonymousCompleteHandler = async(user) => { 
 
        let number = userDataRender.length + 1;
        
        let element = makeUserRecord(user); 
        element.number = number
        
        setTotal(number)

        setUserData(prevItems => { 
            return [...prevItems, element];
        });  

        setUserDataRender(prevItems => { 
            return [...prevItems, element];
        });  
        
    }

    const toggleShowAnonumous = (value) => {
        setShowAnonymous(value)

        if (value) {
            setUserDataRender(
                userData.filter(data =>
                    data.handle.indexOf("ANON_") >= 0
            )); 
        }
        else {
            setUserDataRender(
                userData.filter(data =>
                    data.handle.indexOf("ANON_")< 0
            )); 
        }

    }


    const updateAppUserStatusHandler = async (user, status) => {   
        let result = await updateAppUserStatus(user, status);

        if(result) {
          
          
           console.log("updateAppUserStatusHandler status ", status)
           
            setUserData(userData.map(item => { 
                if (item.appUserId === user.appUserId){ 
                    return {...item, status:status}
                    
                } 
                else return item
            })); 

            setUserDataRender(userDataRender.map(item => { 
                if (item.appUserId === user.appUserId){ 
                    return {...item, status:status}
                    
                } 
                else return item
            })); 
 
        }
    }

    
    const updateGroupStatusHandler = async (group, status) => {   
        group.status = status
        let result = await updateAppGroup(group);

        if(result) { 

           console.log("updateGroupStatusHandler status ", status)
           
            setGroupData(groupData.map(item => { 
                if (item.groupId === group.groupId){ 
                    return {...item, status:status}
                    
                } 
                else return item
            })); 

            setGroupDataRender(groupDataRender.map(item => { 
                if (item.groupId === group.groupId){ 
                    return {...item, status:status}
                    
                } 
                else return item
            }));  
        }
    }



    const deleteSignupHandler = async () => {
        toggleDeleteSignupModal() 
        let result = await deleteAppSignup(modalState.signUpToDelete);
        if(result === true) {

            setSignupData(
                signupData.filter(data => data.handle!= modalState.signUpToDelete.handle)
            );  
            setSignupDataRender(
                signupDataRender.filter(data => data.handle!= modalState.signUpToDelete.handle)
            ); 
        }
    }


    

    const exportAppUserHandler = async () => { 
       
        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;
        let data = {
            displayAppId:currentApp.displayAppId,
            appId:currentApp.appId,
            groupId:filter.groupId
        }
        await exportAppUser(data) 
    }


    const deleteAppGroupHandler = async () => {

        toggleDeleteAppGroupModal() 
        
        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;
        
        
        let result = await deleteAppGroup(modalState.group);
        if(result) {

            setGroupData(
                groupData.filter(data => data.groupId != modalState.group.groupId)
            );  
            setGroupDataRender(
                groupDataRender.filter(data => data.groupId != modalState.group.groupId)
            ); 
        }
    }


    const deleteAppUserHandler = async () => {

        toggleDeleteAppUserModal() 
        
        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;
        
        
        let result = await deleteAppUser(modalState.user, filter.groupId);
        if(result) {

            setUserData(
                userData.filter(data => data.groupId!= modalState.user.handle)
            );  
            setUserDataRender(
                userDataRender.filter(data => data.handle!= modalState.user.handle)
            ); 
        }
    }



    const verifyPasskey = async () => {
        try { 
            
            let challenge = await verify();
            if(challenge.error) {
                return;
            }

            let asseResp = await startAuthentication({ optionsJSON: challenge });
            let authn = await verifyComplete(asseResp);
            if (authn.error) {
                setMessage(`Whoop! ${authn.error.message}.`, "error")
                return false
            }

            return true;
        } catch (error) {
            return false;
        }
    }


    const resetAppUserPasskeyHandler = async () => {

        toggleEditAppUserModal() 
       

        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;
        
        let result = await resetAppUserPasskey(modalState.user); 
        if(result) setMessage("Passkey has been reset.")
        else setMessage("Passkey reset failed.", "error")
    }
  

     
    const handleCreateSignupInvite = async () => { 
        
        let emails = inputData.signupInvite

        console.log("handleCreateSignupInvite emails ", emails)

        if(!validateSignupEmail(emails)){
            setMessage("Please enter valid email", "error")
            return 
        } 
        let result = await createAppInvite(currentApp.appId, emails)
        
        if (result.invitedData) {

            for (let index = 0; index < result.invitedData.length; index++) { 
                let element = makeSignupRecord(result.invitedData[index], index); 
                element.number = index + 1

                setSignupData(prevItems => { 
                    return [element, ...prevItems];
                });

                setSignupDataRender(prevItems => { 
                    return [element, ...prevItems];
                });  
               
            }

            console.log("createAppInvite result ", result)

            // setSignupData(signupData.map((item, index) => { 
            //     return { ...item, number: index + 1 }; 
            // }));

            // setSignupDataRender(signupDataRender.map((item, index) => { 
            //     return { ...item, number: index + 1 }; 
            // }));

        }
        toggleCreateSignupModal()

    }


    const onKeyEnterDown = (event) => {
        if(event.keyCode == 13) handleVerifyHandle()
    }

    const handleVerifyHandle = async () => {
       

        if(!validateSignupEmail(inputData.handle)){
            setMessage("Please enter valid email", "error")
            return 
        } 

        let data = {
            appId: app.appId,
            handle : inputData.handle
        }

        let result = await verifyUser(data); 
        if (result.error) {
            setMessage(result.error.message, "error")
            return
        } 

        let attResp = await startAuthentication({ optionsJSON: result });
        attResp.handle = data.handle;
        
        attResp.appId = data.appId;

        let authn = await verifyUserComplete(attResp, true);
        if (authn.error) {
            setMessage(authn.error.message, "error")
        }
        else setModalState({ ...modalState, ["showVerify"]:!modalState.showVerify })   
        

    }


    const formatDate = (dateString) => {
        const options = { year: "2-digit", month: "2-digit", day: "2-digit", hour: 'numeric', hour12: true}
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    const formatFullDate = (dateString) => {
        const options = { year: "2-digit", month: "2-digit", day: "2-digit", hour: 'numeric', hour12: true, minute:'numeric'}
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    const makeSignupRecord = (item) => { 
        
       
        if (item.status == "active") item.status = <MKBadge variant="contained" badgeContent="active" color="success" size="xs" container />
        else item.status = <MKBadge variant="contained" badgeContent="pending" color="secondary" size="xs" container />
        item.created = formatDate(item.createdAt)
        item.updated = formatDate(item.updatedAt)
        item.hide = false
        item.displayName = item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : ""
        

        item.control = <MKButton variant="text" color="error" onClick={ () => toggleDeleteSignupModal(item)} iconOnly><Icon>delete</Icon></MKButton>
        return item
          
    }

    
    const makeGroupRecord = (item) => { 
    
        item.created = formatDate(item.createdAt)
        item.updated = formatDate(item.updatedAt) 
        item.hide = false  
        return item
          
    }


    const getRandomKey = (index) => {
        return  `${index}${Date.now()}`
    }

    const makeUserRecord = (item) => { 
       
        item.created = formatDate(item.createdAt)
        item.updated = formatDate(item.updatedAt)
        item.lastLogin = formatFullDate(item.lastLogin)
        item.displayName = item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : ""
        item.hide = false  
        return item
          
    }


    function validateSignupEmail (emails){

        if(emails === "" || emails === undefined) return false

        emails = emails.split(",")
        for (let index = 0; index < emails.length; index++) {
            const email = emails[index];
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)){
                return false
            }
        }
        console.log("validateSignupEmail emails ", emails)
        return emails
    } 

    const onChangeInputData = (evt) => {
        setInputData({...inputData, [evt.target.name]: evt.target.value})
    }

    const onChangeGroupName = (item) => {
        
        let groupId = item.split(" - ")[0]; 
        if(groupId != "None") {
            setFilter({
                ...filter,
                ["groupId"]: groupId,
                ["search"]: search
            });
        }
        else {
            setFilter({
                ...filter,
                ["groupId"]: null,
                ["search"]: search
            });
        } 

        setSelectedGroup(item)
        
    }

    
    const handleChangeRowsPerPage = (value) => {

        console.log("handleChangeRowsPerPage newPage ", value);
        setFilter({
            ...filter,
            ["limit"]: value,
            ["offset"] : 1
        });

        //setTotalPage( Math.ceil(total/value)) 

        setRowsPerPage(value);
        setPage(1); 
       
    };

    const handleChangePage = (event, newPage) => {
        console.log("handleChangePage newPage ", newPage); 
        setPage(newPage);
        setFilter({
            ...filter,
            ["offset"]: newPage
        });

        
    };

    const getGroupList = () => {
        let groups = groupDataRender.map(item => `${item.groupId} - ${item.name}` );
        groups.unshift("None");
        return groups
    }
  

    return( 
        <MKBox p={2}>
            <MKTypography variant="h5"  >Application Users</MKTypography>
            <MKBox  xs={12} display="flex" justifyContent={"space-between"} py={3}>

                <Grid container  >
                    <Grid item  xs={12} md={6} pb={2}>
                        <AppBar position="static">
                            <Tabs value={modalState.activeTabUser}  onChange={handleTabUserType}>
                                <Tab label="Users" value={1} />
                                {app.signup === "open" && <Tab label="Signups"  value={2}/> }
                                {app.signup === "invite" && <Tab label="Invites" value={2}  /> }
                                <Tab label="Groups" value={3} />
                            </Tabs>
                        </AppBar> 
                    </Grid> 
                    <Grid item  xs={12} md={6} textAlign="right" >
                        <MKInput
                            variant="standard"
                            placeholder="Search"
                            id = "searchValue"
                            name = "searchValue"
                            autoFocus={true}
                            value={search} 
                            onKeyDown = {onKeyEnterSearch}
                            onChange={e => {onSearchUserSignup(e)} }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ), 
                            }} />
                    </Grid> 
                 </Grid> 

            </MKBox> 
          
            
            <CustomTabPanel value={modalState.activeTabUser} index={1}>  

                <Grid container item xs={12} lg={12} justifyContent="space-between" >
               
                    <MKBox display="flex" alignItems="center" >
                        <MKBox alignItems="center" justifyContent="left" display="flex" >

                            <MKTypography variant="body2" color="text">  Show:  </MKTypography> 
                            <Dropdowns items={[25,  100, 150]} defaultValue = {rowsPerPage}    onChange={handleChangeRowsPerPage}  /> 
                            <MKTypography variant="body2" color="text"> entries  </MKTypography> 

                            <MKBox px={3}> 
                                <MKTypography variant="body2" color="text"> Total User: {total}  </MKTypography>
                            </MKBox>
                        </MKBox>

                        {app.anonymousLoginEnabled && 
                            <MKBox> 
                                <Switch checked={showAnonymous} onChange={() => toggleShowAnonumous(!showAnonymous)} /> 
                                <MKTypography variant="button"  color="text"  fontWeight="regular"  ml={1} >
                                    Show Anonymous 
                                </MKTypography>
                            </MKBox>
                        } 
                           
                        {
                            groupDataRender.length > 0 ? 
                            <MKBox alignItems="center" justifyContent="left" display="flex" > 
                                <MKTypography variant="body2" color="text">  Group: </MKTypography> 
                                <Dropdowns items={  getGroupList() } defaultValue = {selectedGroup}  onChange={onChangeGroupName}  /> 
                            </MKBox>
        
                            :
                            <MKBox alignItems="center" justifyContent="left" display="flex" > 
                                <MKTypography variant="body2" color="text">  Group:&nbsp;</MKTypography> 
                                <MKTypography variant="body2" color="text">None </MKTypography> 
                            </MKBox>
     
                        }
                        
                       


                    </MKBox>

                    { (currentApp.relyPartyId === undefined || currentApp.relyPartyId === "") &&
                    <Stack direction="row" spacing={2}>
                        { selectedGroup != "None" ?
                        <Tooltip title="add user group" placement="top">
                            <MKButton variant="outlined" color="info" onClick={() => toggleAddUserGroupModal()} px={2} iconOnly> <Icon>group_add</Icon> </MKButton>
                        </Tooltip>
                        : null
                        }
                        <Tooltip title="Create user signup" placement="top">
                            <MKButton variant="outlined" color="info" onClick={() => toggleTestUserModal("showSignup")} px={2} iconOnly> <Icon>person_add</Icon> </MKButton>
                        </Tooltip>

                        <Tooltip title="Login app user" placement="top">
                            <MKButton variant="outlined" color="info" onClick={() => toggleTestUserModal("showLogin")} px={2} iconOnly><Icon>login</Icon></MKButton>
                        </Tooltip>
                        { app.anonymousLoginEnabled &&  
                        <Tooltip title="Login app anonumous user" placement="top">
                            <MKButton variant="outlined" color="info" onClick={() => toggleTestUserModal("showAnonymousLogin")} px={2} iconOnly><Icon>panorama_photosphere</Icon></MKButton>
                        </Tooltip>
                        }
                        <Tooltip title="Verify app user handle" placement="top">
                            <MKButton variant="outlined" color="info" onClick={() => toggleTestUserModal("showVerify")} px={2} iconOnly><Icon>fingerprint</Icon></MKButton>
                        </Tooltip>
                        <Tooltip title="Export User" placement="top">
                            <MKButton variant="outlined" color="info" onClick={exportAppUserHandler} px={2} iconOnly><Icon>download_2</Icon></MKButton>
                        </Tooltip>
                    </Stack>
                    }

                    
                </Grid>

                
                <TableContainer sx={{ maxHeight: 650 }}>
                    <Table responsive="sm">
                        <thead>
                        <TableRow key={getRandomKey("user")}>
                        {userTableHeader.map((column) => (
                            <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ maxWidth: column.maxWidth }}
                            className="colunmHeader"
                            >
                            {column.name}
                            </TableCell>
                        ))}
                        </TableRow>
                        </thead>
                    <TableBody>
                        {userDataRender
                        //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((user) => {
                            return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={user._id}>
                                {userTableHeader.map((column) => {

                                    let value = user[column.id];

                                    if (column.id === "status") { 

                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                                { value === "active" ?  <MKBadge variant="contained" badgeContent= {value} color="success" size="xs" container /> :
                                                                       <MKBadge variant="contained" badgeContent= {value} color="error" size="xs" container />
                                                }

                                            </TableCell>
                                        );
                                    }

                                    else if (column.id === "control") {
                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                                <MKBox>
                                                    
                                                    <MKButton variant="text" color="info" onClick={ () => toggleEditAppUserModal(user)} iconOnly px={2} ><Icon>key</Icon></MKButton> &nbsp;
                                                    <MKButton  variant="text" color="error" onClick={ () => toggleDeleteAppUserModal(user)} iconOnly px={2}><Icon>delete</Icon></MKButton> &nbsp;
                                                    { user.status === "active" ?   
                                                        <Tooltip title="suspend this user" placement="top">
                                                        <MKButton variant="text" color="error" onClick={ () => updateAppUserStatusHandler(user, "suspended")} iconOnly px={2}><Icon>person_off</Icon></MKButton>
                                                        </Tooltip> : 
                                                        <Tooltip title="activate this user" placement="top">
                                                        <MKButton variant="text" color="info" onClick={ () => updateAppUserStatusHandler(user, "active")} iconOnly px={2}><Icon>settings_accessibility</Icon></MKButton>
                                                        </Tooltip>
                                                    }

                                                </MKBox>   
                                            </TableCell>
                                        );
                                    }
                                    else { 


                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                            {column.format && typeof value === 'number'
                                                ? column.format(value)
                                                : value}
                                            </TableCell>
                                        );
                                    }
                                })}
                            </TableRow>
                            );
                        })}
                    </TableBody>

                    
                    </Table>
                </TableContainer>

                
              
                {Math.ceil(total/rowsPerPage) > 1 &&  
                    <Grid container item xs={12} lg={5} justifyContent="center" mx="auto" py={3}> 
                        <Pagination count={Math.ceil(total/rowsPerPage)} showFirstButton showLastButton page={page} onChange={handleChangePage} />
                    </Grid>
                }
            </CustomTabPanel>


            <CustomTabPanel value={modalState.activeTabUser} index={2}> 

                <MKBox display="flex" justifyContent="space-between"> 
                    
                    <MKBox alignItems="center" justifyContent="left" display="flex">

                        <MKTypography variant="body2" color="text">  Show:  </MKTypography> 
                        <Dropdowns items={[25,  100, 150]} defaultValue = {rowsPerPage}  onChange={handleChangeRowsPerPage}   /> 
                        <MKTypography variant="body2" color="text"> entries  </MKTypography> 

                        <MKBox px={3}> 
                            <MKTypography variant="body2" color="text"> Total Record: {total}  </MKTypography>
                        </MKBox>
                    </MKBox>

                    {app.signup === "invite" &&
                    <Tooltip title="Add Record" placement="top">
                        <MKButton variant="outlined" color="info" onClick={toggleCreateSignupModal} px={2} iconOnly> <Icon sx={{ mr: 1 }}>person_add</Icon> </MKButton>
                    </Tooltip>
                    }

                    {app.signup === "open" && (app.relyPartyId === undefined  || app.relyPartyId === "") &&
                    <Tooltip title="Add Record" placement="top">
                        <MKButton variant="outlined" color="info" onClick={toggleCreateSignupModal} px={2} iconOnly> <Icon sx={{ mr: 1 }}>person_add</Icon> </MKButton>
                    </Tooltip>
                    }   

                </MKBox>
                {signupDataRender.length > 0 ?


                <TableContainer sx={{ maxHeight: 650 }}>
                <Table responsive="sm">
                    <thead>
                    <TableRow >
                    {signUpTableHeader.map((column) => (
                        <TableCell
                        key={getRandomKey('signup'+column.id)}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="colunmHeader"
                        >
                        {column.name}
                        </TableCell>
                    ))}
                   
                    </TableRow>
                    </thead>
                <TableBody>
                    {signupDataRender
                    //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item) => {
                        return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={getRandomKey("signup"+item.number)} >
                            {signUpTableHeader.map((column) => {

                                let value = item[column.id];

                                return (
                                    <TableCell key={getRandomKey('signupcell'+column.id)} align={column.align} className="tableCell">
                                    {column.format && typeof value === 'number'
                                        ? column.format(value)
                                        : value}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                        );
                    })}
                </TableBody>


                </Table>
                </TableContainer>

 
                :
                    <MKTypography color="info" pr={4}>No Record</MKTypography>
                }

                {Math.ceil(total/rowsPerPage) > 1 &&  
                    <Grid container item xs={12} lg={5} justifyContent="center" mx="auto" py={3}> 
                        <Pagination count={Math.ceil(total/rowsPerPage)} showFirstButton showLastButton page={page} onChange={handleChangePage} />
                    </Grid>
                }

            </CustomTabPanel>

            <CustomTabPanel value={modalState.activeTabUser} index={3}> 

                <MKBox display="flex" justifyContent="space-between"> 
                    
                    <MKBox alignItems="center" justifyContent="left" display="flex">

                        <MKTypography variant="body2" color="text">  Show:  </MKTypography> 
                        <Dropdowns items={[25,  100, 150]} defaultValue = {rowsPerPage}  onChange={handleChangeRowsPerPage}   /> 
                        <MKTypography variant="body2" color="text"> entries  </MKTypography> 

                        <MKBox px={3}> 
                            <MKTypography variant="body2" color="text"> Total Record: {total}  </MKTypography>
                        </MKBox>
                    </MKBox>

                   
                    <Tooltip title="Add Group" placement="top">
                        <MKButton variant="outlined" color="info" onClick={toggleCreateGroupModal} px={2} iconOnly> <Icon sx={{ mr: 1 }}>group_add</Icon> </MKButton>
                    </Tooltip>
                </MKBox>

                {groupDataRender.length > 0 ? <TableContainer sx={{ maxHeight: 650 }}>
                <Table responsive="sm">
                    <thead>
                    <TableRow key={getRandomKey("group")}>
                    {groupTableHeader.map((column) => (
                        <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="colunmHeader"
                        >
                        {column.name}
                        </TableCell>
                    ))}
                    </TableRow>
                    </thead>
                <TableBody>
                    {groupDataRender
                        //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((group) => {
                            return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={getRandomKey("group"+group.number)}>
                                {groupTableHeader.map((column) => {

                                    let value = group[column.id];

                                    if (column.id === "status") { 

                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                                { value === "active" ?  <MKBadge variant="contained" badgeContent= {value} color="success" size="xs" container /> :
                                                                       <MKBadge variant="contained" badgeContent= {value} color="error" size="xs" container />
                                                }

                                            </TableCell>
                                        );
                                    }

                                    else if (column.id === "control") {
                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                                <MKBox>
                                                    
                                                    <MKButton variant="text" color="info" onClick={ () => toggleEditAppGroupModal(group)} iconOnly px={2} ><Icon>edit</Icon></MKButton> &nbsp;
                                                    <MKButton  variant="text" color="error" onClick={ () => toggleDeleteAppGroupModal(group)} iconOnly px={2}><Icon>delete</Icon></MKButton> &nbsp;
                                                    { group.status === "active" ?   
                                                        <Tooltip title="suspend this group" placement="top">
                                                        <MKButton variant="text" color="error" onClick={ () => updateGroupStatusHandler(group, "suspended")} iconOnly px={2}><Icon>group_off</Icon></MKButton>
                                                        </Tooltip> : 
                                                        <Tooltip title="activate this group" placement="top">
                                                        <MKButton variant="text" color="info" onClick={ () => updateGroupStatusHandler(group, "active")} iconOnly px={2}><Icon>group</Icon></MKButton>
                                                        </Tooltip>
                                                    }
                                                    <MKButton color="white" onClick={() => {navigator.clipboard.writeText(group.groupId)}}>
                                                        <Icon fontSize="large">copy</Icon>
                                                    </MKButton>

                                                </MKBox>   
                                            </TableCell>
                                        );
                                    }
                                    else { 


                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                            {column.format && typeof value === 'number'
                                                ? column.format(value)
                                                : value}
                                            </TableCell>
                                        );
                                    }
                                })}
                            </TableRow>
                            );
                        })}
                </TableBody>


                </Table>
                </TableContainer>


                :
                    <MKTypography color="info" pr={4}>No Record</MKTypography>
                }

                {Math.ceil(total/rowsPerPage) > 1 &&  
                    <Grid container item xs={12} lg={5} justifyContent="center" mx="auto" py={3}> 
                        <Pagination count={Math.ceil(total/rowsPerPage)} showFirstButton showLastButton page={page} onChange={handleChangePage} />
                    </Grid>
                }

            </CustomTabPanel>





        <Modal open={modalState.showSignup} onClose={() => toggleTestUserModal("showSignup")} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showSignup} timeout={300}>
          <Grid container item xs={12} lg={5} justifyContent="center" mx="auto">
          <Card>
                <MKBox
                variant="contained"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center" 
                >
                    <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Sign Up 
                    </MKTypography>
                
                </MKBox>
           
                <MKBox pb={3} px={3}>
                    <MKBox display="flex" alignitems="center" justifyContent="space-between" p={2}>
                        <MKTypography variant="h5">Signup to Application '{app.name}'</MKTypography> 
                         
                    </MKBox>
                    <MKBox display="flex" alignitems="center" justifyContent="space-between" px={2}>
                        <MKTypography variant="body2" color="text">Enter your user information</MKTypography>
                    </MKBox>
                    
                    <AppSignup app={app} dismiss={() => toggleTestUserModal("showSignup")}  onSuccess={getAppUserData}/>
                </MKBox>
                
                </Card>
            </Grid>
          </Slide>
        </Modal>

        
        <Modal open={modalState.showCreateGroup} onClose={() => toggleCreateGroupModal("showCreateGroup")} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showCreateGroup} timeout={300}>
          <Grid container item xs={12} lg={5} justifyContent="center" mx="auto">
          <Card>
                <MKBox
                variant="contained"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center" 
                >
                    <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Create Group
                    </MKTypography>
                
                </MKBox>
           
                <MKBox pb={3} px={3}>
                    <MKBox display="flex" alignitems="center" justifyContent="space-between" p={2}>
                        <MKTypography variant="h5">Create group for application '{app.name}'</MKTypography> 
                         
                    </MKBox>
                    <MKBox display="flex" alignitems="center" justifyContent="space-between" px={2}>
                        <MKTypography variant="body2" color="text">Enter your group information</MKTypography>
                    </MKBox>
                    
                    <AppGroup app={app} dismiss={() => toggleTestUserModal("showCreateGroup")}  onSuccess ={() => { getAppGroupData(), toggleCreateGroupModal()}}/>
                </MKBox>
                
                </Card>
            </Grid>
          </Slide>
        </Modal>


        <Modal open={modalState.showAnonymousLogin} onClose={() => toggleTestUserModal("showAnonymousLogin")} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showAnonymousLogin} timeout={300}>
          <Grid container item xs={12} lg={5} justifyContent="center" mx="auto">

            <Card>
                <MKBox
                variant="contained"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center" 
                >
                    <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Login
                    </MKTypography>
                
                </MKBox>
           
                <MKBox pb={3} px={3}> 
                    <AppLogin app={app} anonymous = {true} dismiss={() => toggleTestUserModal("showAnonymousLogin")}  onSuccess ={ loginAnonymousCompleteHandler}/>

                 
                </MKBox>
                
            </Card>
            </Grid>
          </Slide>
        </Modal>


        <Modal open={modalState.showLogin} onClose={() => toggleTestUserModal("showLogin")} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showLogin} timeout={300}>
          <Grid container item xs={12} lg={5} justifyContent="center" mx="auto">

            <Card>
                <MKBox
                variant="contained"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center" 
                >
                    <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Login
                    </MKTypography>
                
                </MKBox>
           
                <MKBox pb={3} px={3}> 

                    <AppLogin app={app} anonymous = {false} dismiss={() => toggleTestUserModal("showLogin")}  onSuccess ={() => { }}/>

                 
                </MKBox>
                
            </Card>
            </Grid>
          </Slide>
        </Modal>

        

        <Modal open={modalState.showCreateInvite} onClose={toggleCreateSignupModal} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showCreateInvite} timeout={300}>
            <MKBox
              position="relative" 
              sx={{ maxWidth: 'md' }}
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
              <MKBox  p={2}>
                <MKTypography variant="h5">Enter user email to invite to signup.</MKTypography> 
                <MKTypography variant="body2" color="text">Use camma separation for multiple email</MKTypography>
              </MKBox>
               
              <Divider sx={{ my: 0 }} />
              <MKBox p={2}>
                <MKInput  onChange={onChangeInputData}  name = "signupInvite"  label="Emails" multiline fullWidth rows={6} placeholder="jojo@appkeyf.com, toto@appkeyf.com"/>
              </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox display="flex" justifyContent="space-between" p={1.5}>
                <MKButton variant="gradient" color="dark" onClick={toggleCreateSignupModal}>
                  cancel
                </MKButton>
                <MKButton variant="gradient" color="primary" onClick={handleCreateSignupInvite}>
                  Submit
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

        

{/* 
        <Modal open={modalState.showCreateSignup} onClose={toggleCreateSignupModal} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showCreateSignup} timeout={300}>
            <MKBox
              position="relative" 
              sx={{ maxWidth: 'md' }}
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
              <MKBox  p={2}>
                <MKTypography variant="h5">Enter user information to signup.</MKTypography>  
              </MKBox>
              {errorMessageSingup && <MKTypography variant="button" color="error" px={2}>{errorMessageSingup}</MKTypography> }
              <Divider sx={{ my: 0 }} />
              <MKBox p={2}>
                <MKBox py={2}>
                    <MKInput  label="Display Name"  onChange={onChangeInputData}    fullWidth name="displayName" autoFocus={true}  />
                </MKBox>
                <MKBox >
                    <MKInput  label="Handle" onChange={onChangeInputData}   fullWidth name="handle" />
                </MKBox>
            </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox display="flex" justifyContent="space-between" p={1.5}>
                <MKButton variant="gradient" color="dark" onClick={toggleCreateSignupModal}>
                  cancel
                </MKButton>
                <MKButton variant="gradient" color="primary" onClick={handleCreateSignupData}>
                  Submit
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal> */}



        <Modal open={modalState.showVerify} onClose={toggleVerifyModal} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showVerify} timeout={300}>
            <MKBox
              position="relative" 
              sx={{ maxWidth: 'md' }}
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
              <MKBox  p={2}>
                <MKTypography variant="h5">Enter user handle to verifiy.</MKTypography>  
              </MKBox>
              
              <Divider sx={{ my: 0 }} />
              <MKBox p={2}>
                
                <MKBox >
                    <MKInput  label="Handle"  onChange={onChangeInputData}   fullWidth name="handle" 
                    inputProps={{ autoComplete: "off", autoCapitalize: "none", style: { textTransform: "lowercase" } }}
                    onKeyDown = {onKeyEnterDown}/>
                </MKBox>
            </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox display="flex" justifyContent="space-between" p={1.5}>
                <MKButton variant="gradient" color="dark" onClick={toggleVerifyModal}>
                  cancel
                </MKButton>
                <MKButton variant="gradient" color="primary" onClick={handleVerifyHandle}>
                  Submit
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal>

 
       



        <Modal open={modalState.showDeleteSignup} onClose={toggleDeleteSignupModal} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showDeleteSignup} timeout={300}>
            <MKBox
              position="relative"
              sx={{ maxWidth: 'md' }}
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                <MKTypography variant="h5">Are you sure to delete this app?</MKTypography> 
              </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox p={2}>
                <MKTypography variant="body">This transaction can't undo.</MKTypography>
              </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox display="flex" justifyContent="space-between" p={1.5}>
                <MKButton variant="gradient" color="dark" onClick={toggleDeleteSignupModal}>
                  cancel
                </MKButton>
                <MKButton variant="gradient" color="primary" onClick={deleteSignupHandler}>
                  Submit
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal> 

        <Modal open={modalState.showEditAppUser} onClose={toggleEditAppUserModal} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showEditAppUser} timeout={300}>
            <MKBox
              position="relative"
              sx={{ maxWidth: 'md' }}
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                {modalState.user ?  
                    <MKTypography variant="h5">Are you sure to reset passkey for this app user "{modalState.user.displayName}"?</MKTypography> 
                    :
                    <MKTypography variant="h5">Are you sure to reset passkey for this app user?</MKTypography> 
                 
                }
                
                </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox p={2}>
                <MKTypography variant="body">This transaction can't undo.</MKTypography>
                <MKTypography variant="h6">The user will get an email for reseting passkey token.</MKTypography> 
              </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox display="flex" justifyContent="space-between" p={1.5}>
                <MKButton variant="gradient" color="dark" onClick={toggleEditAppUserModal}>
                  cancel
                </MKButton>
                <MKButton variant="gradient" color="primary" onClick={resetAppUserPasskeyHandler}>
                  Submit
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal> 

         

        <Modal open={modalState.showDeleteAppUser} onClose={toggleDeleteAppUserModal} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showDeleteAppUser} timeout={300}>
            <MKBox
              position="relative"
              sx={{ maxWidth: 'md' }}
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
              <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                <MKTypography variant="h5">Are you sure to delete this app user?</MKTypography> 
              </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox p={2}>
                <MKTypography variant="body">This transaction can't undo.</MKTypography>
              </MKBox>
              <Divider sx={{ my: 0 }} />
              <MKBox display="flex" justifyContent="space-between" p={1.5}>
                <MKButton variant="gradient" color="dark" onClick={toggleDeleteAppUserModal}>
                  cancel
                </MKButton>
                <MKButton variant="gradient" color="primary" onClick={deleteAppUserHandler}>
                  Submit
                </MKButton>
              </MKBox>
            </MKBox>
          </Slide>
        </Modal> 

        
        <Modal open={modalState.showEditAppGroup} onClose={toggleEditAppGroupModal} sx={{ display: "grid", placeItems: "center" }}>
          <Slide direction="down" in={modalState.showEditAppGroup} timeout={300}>
            {modalState.group ?
            <MKBox
              position="relative"
              sx={{ maxWidth: 'md' }}
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
                <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                    <MKTypography variant="h5">Update Group Application: {modalState.group.name}</MKTypography> 
                </MKBox>

                <Divider sx={{ my: 0 }} />
                    <AppGroup  app={app} group={modalState.group} dismiss={toggleEditAppGroupModal}  onSuccess ={(group) => {  getAppGroupData(), toggleEditAppGroupModal(group) }}/>
                <Divider sx={{ my: 0 }} />
                
                 
            </MKBox> : null
            }
          </Slide>
        </Modal> 


        
        <Modal open={modalState.showDeleteAppGroup} onClose={toggleDeleteAppGroupModal} sx={{ display: "grid", placeItems: "center" }}>
        <Slide direction="down" in={modalState.showDeleteAppGroup} timeout={300}>
            <MKBox
            position="relative"
            sx={{ maxWidth: 'md' }}
            display="flex"
            flexDirection="column"
            borderRadius="xl"
            bgColor="white"
            shadow="xl"
            >
            <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                <MKTypography variant="h5">Are you sure to delete this app group?</MKTypography> 
            </MKBox>
            <Divider sx={{ my: 0 }} />
            <MKBox p={2}>
                <MKTypography variant="body">This transaction can't undo.</MKTypography>
            </MKBox>
            <Divider sx={{ my: 0 }} />
            <MKBox display="flex" justifyContent="space-between" p={1.5}>
                <MKButton variant="gradient" color="dark" onClick={toggleDeleteAppGroupModal}>
                cancel
                </MKButton>
                <MKButton variant="gradient" color="primary" onClick={deleteAppGroupHandler}>
                Submit
                </MKButton>
            </MKBox>
            </MKBox>
        </Slide>
        </Modal> 


        <Modal open={modalState.showAddUserGroup} onClose={toggleAddUserGroupModal} sx={{ display: "grid", placeItems: "center" }}>
        <Slide direction="down" in={modalState.showAddUserGroup} timeout={300}>
            <MKBox
            position="relative"
            sx={{ maxWidth: 'md' }}
            display="flex"
            flexDirection="column"
            borderRadius="xl"
            bgColor="white"
            shadow="xl"
            >
                <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
                    <MKTypography variant="h5">Manager User Group: {selectedGroup}</MKTypography> 
                </MKBox>
                <Divider sx={{ my: 0 }} />

                <MKBox display="flex" justifyContent="space-between" p={1.5}>
                    <AddUserGroup app={currentApp} groupId={selectedGroup.split(" - ")[0] } dismiss={() => toggleAddUserGroupModal()}  onSubmit={(data) => submitUpdateUserGroup(data)} />
                </MKBox> 
            
            </MKBox>
        </Slide>
        </Modal> 



    </MKBox>

        
    )




    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
    
        return (
        <MKBox
            role="tabpanel"
            hidden={value !== index}
            id={`app-tabpanel-${index}`}
            aria-labelledby={`app-tab-${index}`}
            {...other}
        >
            {value === index && <MKBox>{children}</MKBox>}
        </MKBox>
        );
    }
    
    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };
  

}
